import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { getServiceBookPortal } from '../../utils/serviceBookPortals';

/**
 * "Sähköinen huoltokirja" in the work order header: a link to the manufacturer's digital
 * service book portal for this make. Only a link: no manufacturer offers an API for writing
 * entries, so the workshop records the service in the portal itself (the VIN copy button next
 * to this is for pasting into it). Makes without a portal open to independents show nothing.
 */
function ServiceBookLink({ manufacturer }) {
  const { t } = useTranslation();
  const portal = getServiceBookPortal(manufacturer);
  if (!portal) return null;

  return (
    <Box sx={{ mt: 0.25, ml: -0.5 }}>
      <Tooltip title={t('serviceBook.manufacturerPortal')} placement="bottom-start">
        <Button
          size="small"
          component="a"
          href={portal.url}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<MenuBookOutlined sx={{ fontSize: '16px !important' }} />}
          endIcon={<OpenInNewIcon sx={{ fontSize: '14px !important' }} />}
          data-testid="service-book-link"
          data-portal={portal.key}
          sx={{
            textTransform: 'none',
            fontSize: '13px',
            color: 'text.secondary',
            px: 0.5,
            py: 0,
            minWidth: 0,
            textAlign: 'left',
          }}
        >
          {t('serviceBook.openPortal', { portal: portal.name })}
        </Button>
      </Tooltip>
    </Box>
  );
}

export default ServiceBookLink;
